document.addEventListener("DOMContentLoaded", function () {
    let selectedBoxes = [];
    let totalQuantity = 0;
    let mainQuantityShow = document.getElementById("maximum_selected_show_message");
    let toatlQuantityBox = document.getElementById("total_select_quanitty_message");
    let quantityInput = document.querySelector(".choco_quantity__input");
    let addToCartButton = document.querySelector(".Choco_ProductSubmitButton");

    function getMaxTotalQuantity() {
        return parseInt(quantityInput.value, 10) || 1;
    }

    function updateDisplay() {
        let headingsText = selectedBoxes.map(item => `${item.quantity} × ${item.heading}`).join(", ");
        document.getElementById("selected-headings").textContent = headingsText;
        document.getElementById("selected-sku").value = selectedBoxes.map(item => `${item.quantity} × ${item.sku}`).join(", ");
        document.getElementById("selected-box-design").value = headingsText;
        document.getElementById("error_message_choose_").style.display = selectedBoxes.length ? "none" : "block";

        // Check total quantity and hide/show message accordingly
        let maxTotalQuantity = getMaxTotalQuantity();
        if (totalQuantity === maxTotalQuantity) {
            toatlQuantityBox.style.display = "none"; // Hide message if total matches
        }
    }

    function adjustSelectedBoxes() {
        let maxTotalQuantity = getMaxTotalQuantity();
        while (totalQuantity > maxTotalQuantity) {
            let lastBox = selectedBoxes.pop();
            let boxElement = document.querySelector(`.choco-box[data-heading="${lastBox.heading}"]`);
            if (boxElement) {
                boxElement.classList.remove("selected");
                boxElement.querySelector(".quantity-box").style.display = "none";
                boxElement.querySelector(".qty-input").value = 1;
            }
            totalQuantity--;
        }
        updateDisplay();
    }

    function updateFunction() {
        mainQuantityShow.style.display = "none";
        totalQuantity = selectedBoxes.reduce((sum, item) => sum + item.quantity, 0);
        adjustSelectedBoxes();
    }

    quantityInput.addEventListener("input", updateFunction);
    quantityInput.addEventListener("change", updateFunction);

    let observer = new MutationObserver(updateFunction);
    observer.observe(quantityInput, { attributes: true, attributeFilter: ["value"] });

    document.querySelectorAll(".choco-box img, .choco-box .choco_background_color").forEach(element => {
        element.addEventListener("click", function () {
            let maxTotalQuantity = getMaxTotalQuantity();
            let box = this.closest(".choco-box");
            let heading = box.getAttribute("data-heading");
            let sku = box.getAttribute("data-sku");
            let quantityBox = box.querySelector(".quantity-box");
            let qtyInput = box.querySelector(".qty-input");
            let currentQuantity = parseInt(qtyInput.value, 10);

            if (box.classList.contains("selected")) {
                mainQuantityShow.style.display = "none";
                totalQuantity -= currentQuantity;
                selectedBoxes = selectedBoxes.filter(item => item.heading !== heading);
                box.classList.remove("selected");
                quantityBox.style.display = "none";
                qtyInput.value = 1;
            } else {
                if (totalQuantity >= maxTotalQuantity) {
                    mainQuantityShow.style.display = "block";
                    return;
                }
                box.classList.add("selected");
                selectedBoxes.push({ heading, sku, quantity: 1 });
                quantityBox.style.display = "block";
                totalQuantity++;
            }

            adjustSelectedBoxes();
            updateDisplay();
        });
    });

    document.querySelectorAll(".choco-box").forEach(box => {
        let qtyInput = box.querySelector(".qty-input");
        let minusBtn = box.querySelector(".qty-minus");
        let plusBtn = box.querySelector(".qty-plus");

        minusBtn.addEventListener("click", function () {
            let qty = parseInt(qtyInput.value, 10);
            if (qty > 1) {
                qtyInput.value = qty - 1;
                totalQuantity--;
                let heading = box.getAttribute("data-heading");
                selectedBoxes.forEach(item => {
                    if (item.heading === heading) item.quantity = qty - 1;
                });
                updateDisplay();
            }
            mainQuantityShow.style.display = "none";
        });

        plusBtn.addEventListener("click", function () {
            let maxTotalQuantity = getMaxTotalQuantity();
            let qty = parseInt(qtyInput.value, 10);
            if (totalQuantity < maxTotalQuantity) {
                qtyInput.value = qty + 1;
                totalQuantity++;
                let heading = box.getAttribute("data-heading");
                selectedBoxes.forEach(item => {
                    if (item.heading === heading) item.quantity = qty + 1;
                });
                updateDisplay();
            } else {
                mainQuantityShow.style.display = "block";
            }
        });
    });

    addToCartButton.addEventListener("click", function (event) {
        let maxTotalQuantity = getMaxTotalQuantity();
        if (totalQuantity !== maxTotalQuantity) {
            event.preventDefault();
            toatlQuantityBox.style.display = "block"; 
        } else {
            toatlQuantityBox.style.display = "none";
        }
    });

    document.querySelectorAll(".choco_qty-input").forEach(input => {
        input.setAttribute("readonly", true);
    });
});




 document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("choco-container");
    const boxes = Array.from(container.querySelectorAll(".choco-box"));
    boxes.sort((a, b) => {
        return parseInt(a.getAttribute("data-order")) - parseInt(b.getAttribute("data-order"));
    });
    boxes.forEach(box => container.appendChild(box));
});